// DETAIL: (REGARDING REACTIVITY) OBJECTS, ARRAYS, MAPS, etc. AREN'T REACTIVE BY DEFAULT, THEREFORE I AM FUDGING IT BY COMPLETELY REASSIGNING THE OBJECT ON CHANGE.
export default {
  namespaced: true,
  state: {
    busyMap: new Map(),
    busyTimeout: null,
    currentPageName: null,
  },
  getters: {
    getCurrentPageName(state) {
      return state.currentPageName;
    },
    mapOfTasks(state) {
      return state.busyMap;
    },
    busyMessage(state) {
      if (state.busyMap.size > 0) {
        //NOTE: POPPING THE LAST ITEM OFF THE ARRAY REPRESENTATION OF THE MAP, THEN POPPING THE LAST ITEM (MESSAGE) OFF THAT
        return Array.from(state.busyMap)
          .pop()
          .pop();
      }

      return "Working . . .";
    },
    systemIsBusy(state) {
      return state.busyMap.size > 0;
    },
  },
  mutations: {
    setCurrentPageName(state, pageName) {
      state.currentPageName = pageName;
    },
  },
  actions: {
    setBusy({ state, dispatch }, { busyId, busyMsg }) {
      dispatch("clearBusyMapTimeout");

      if (!!busyId) {
        state.busyMap.set(busyId, busyMsg);
        state.busyMap = new Map([...state.busyMap]);
        // console.log("BUSY MAP:", state.busyMap.size);
        state.busyTimeout = setTimeout(() => {
          dispatch("clearAllBusy");
          console.log("CANCELING BUSY STATE");
        }, 120000);
      }
    },
    removeBusy({ state, dispatch }, { busyId }) {
      if (!state.busyMap.has(busyId)) {
        console.log("THERE IS NO BUSY TASK WITH AN ID: " + busyId);
        return false;
      }

      state.busyMap.delete(busyId);
      state.busyMap = new Map([...state.busyMap]);

      if (state.busyMap.size <= 0) {
        dispatch("clearBusyMapTimeout");
      }
    },
    clearAllBusy({ state, dispatch }) {
      state.busyMap = new Map();
      dispatch("clearBusyMapTimeout");
    },
    clearBusyMapTimeout({ state }) {
      if (state.busyTimeout !== null && typeof state.busyTimeout !== "undefined") {
        console.log("RESETTING TIMEOUT");
        clearTimeout(state.busyTimeout);
      }
    },
  },
};
